import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propFunc, propId, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import RfpOneBackLink from '../Link/RfpOneBackLink';
import RfpOneNextLink from '../Link/RfpOneNextLink';
import RfpOnePrevLink from '../Link/RfpOnePrevLink';
const RfpOneHeaderNavPc = (props) => {
    const { driverTargetRef, id, isActiveDriverTarget, isPreview, nextViewRequestId, onClickDriverTarget, prevViewRequestId, title, } = props;
    return (_jsxs("div", Object.assign({ className: 'rfp-header-nav-pc' }, { children: [_jsx("div", Object.assign({ className: 'back_column' }, { children: _jsx(RfpOneBackLink, { id: id, isPreview: isPreview }) })), _jsx("div", Object.assign({ className: 'title_column' }, { children: _jsx("h3", Object.assign({ className: 'title_text' }, { children: title })) })), _jsxs("div", Object.assign({ className: clsx('page_move_column', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : undefined, ref: driverTargetRef, role: 'presentation' }, { children: [_jsx("div", Object.assign({ className: 'prev_column' }, { children: _jsx(RfpOnePrevLink, { id: id, viewRequestId: prevViewRequestId }) })), _jsx("div", Object.assign({ className: 'next_column' }, { children: _jsx(RfpOneNextLink, { id: id, viewRequestId: nextViewRequestId }) }))] }))] })));
};
RfpOneHeaderNavPc.propTypes = {
    driverTargetRef: propShape(),
    id: propId().isRequired,
    isActiveDriverTarget: propBool(),
    isPreview: propBool().isRequired,
    nextViewRequestId: propId(),
    onClickDriverTarget: propFunc(),
    prevViewRequestId: propId(),
    title: propStr().isRequired,
};
RfpOneHeaderNavPc.defaultProps = {
    driverTargetRef: null,
    isActiveDriverTarget: false,
    nextViewRequestId: null,
    onClickDriverTarget: undefined,
    prevViewRequestId: null,
};
export default RfpOneHeaderNavPc;
